<template>
    <div class="vb100List">
        <loader :exitLoader="exitLoader"></loader>
        <navigation :jumpView="jumpView" :activePage="activePage" :componentsNum="componentsNum" :nextPage="nextPage" @setActivePage="setActivePage" @setNextPage="setNextPage" @setLock="setLock" @setJumpView="setJumpView"></navigation>

        <index v-show="activePage == 0" :jumpView="jumpView" :activePage="activePage" :nextPage="nextPage" @setActivePage="setActivePage" @setLock="setLock"></index>
        <page-video v-show="activePage == 1" :jumpView="jumpView" :activePage="activePage" :nextPage="nextPage" @setActivePage="setActivePage" @setLock="setLock"></page-video>
        <main-list v-show="activePage == 2" :jumpView="jumpView" :activePage="activePage" :nextPage="nextPage" @setActivePage="setActivePage" @setLock="setLock" @setNextPage="setNextPage"></main-list>
        <new-zone v-show="activePage == 3" :jumpView="jumpView" :activePage="activePage" :nextPage="nextPage" @setActivePage="setActivePage" @setLock="setLock"></new-zone>
        <city v-show="activePage == 4" :jumpView="jumpView" :activePage="activePage" :nextPage="nextPage" @setActivePage="setActivePage" @setLock="setLock"></city>
        <son v-show="activePage == 5" :jumpView="jumpView" :activePage="activePage" :nextPage="nextPage" @setActivePage="setActivePage" @setLock="setLock"></son>
        <pen-cheng v-show="activePage == 6" :jumpView="jumpView" :activePage="activePage" :nextPage="nextPage" @setActivePage="setActivePage" @setLock="setLock"></pen-cheng>
        <en-list v-show="activePage == 7" :jumpView="jumpView" :activePage="activePage" :nextPage="nextPage" @setActivePage="setActivePage" @setLock="setLock" @setNextPage="setNextPage"></en-list>
        <org v-show="activePage == 8" :jumpView="jumpView" :activePage="activePage" :nextPage="nextPage" @setActivePage="setActivePage" @setLock="setLock"></org>
        
        <div class="next-btn" @click="nextView()" v-if="nextPage != componentsNum && nextPage != 7">
          <i class="iconfont">&#xe67b;</i>
        </div>
    </div>
</template>

<script>
import Navigation from '../components/navigation/navigation';
import Index from "./Index/Index";
import PageVideo from "./PageVideo/PageVideo";
import MainList from "./MainList/MainList"
import NewZone from "./NewZone/NewZone"
import City from "./City/City"
import Son from "./Son/Son"
import PenCheng from "./PenCheng/PenCheng"
import EnList from "./EnList/EnList"
import Org from "./Org/Org"
import Loader from "../components/loader/loader"

export default {
  data() {
      return {
          activePage: 0,
          nextPage: 0,
          lock: false,
          exitLoader: false,
          componentsNum: 8, // 网页个数
          jumpView: 0
      }
  },
  mounted(){
    this.initMousewheel()
    setTimeout(() => {
      this.exitLoader = true
    },2000)
  },
  components: {
    Navigation,Index,PageVideo,MainList,NewZone,City,Son,PenCheng,EnList,Org,Loader
  },
  methods:{
    nextView(){
      if( this.nextPage > this.componentsNum ){
        return
      }
      this.lock = false
      this.nextPage = this.nextPage + 1 
    },
    initMousewheel(){
      let _that = this
      $('.vb100List').mousewheel(function (event, delta) {
        if(_that.activePage == 2){
          return
        }
        if (delta == 1) {
        // 向上滚
          if( _that.lock ){
            if( _that.nextPage - 1 < 0 ){
              return ;
            }
            _that.lock = false
            _that.nextPage = _that.nextPage - 1
            _that.jumpView = _that.nextPage
          }
        } else if (delta == -1) {
          // 向下滚
          if( _that.lock ){
            if( _that.nextPage + 1 > _that.componentsNum ){
              return
            }
            _that.lock = false
            _that.nextPage = _that.nextPage + 1
            _that.jumpView = _that.nextPage
          }
        }
        event.stopPropagation();
        event.preventDefault();
      });
    },
    setActivePage(data){
      this.activePage = data
    },
    setNextPage(data){
      this.nextPage = data
    },
    setLock(data){ // 设施是否可以滚动
      this.lock = data
    },
    setJumpView(data){
      this.jumpView = data
    }
  }
};
</script>

<style lang="stylus" scoped>
.next-btn
  cursor pointer
  position fixed
  left 4.2vw
  bottom 7.4vh
  width: 60px;
  height: 60px;
  background:linear-gradient(-45deg,rgba(214,162,77,1),rgba(255,215,149,1));
  border-radius:50%;
  text-align center
  line-height  60px;
  @media screen and (max-width: 1366px)
    width: 40px;
    height: 40px;
    line-height  40px;
  i 
    font-zise 20px
    color #fff
</style>